import Game from 'Game';
import { IGameState } from 'State/Game/IGameState';

export async function consumePurchase(state: IGameState, product: any) {
    Game.sdk.consumePurchase(state, product);
}
